import { logger } from "@repo/logging";
import type { PulseEvent } from "../pulse";

const PULSE_URL = process.env.NEXT_PUBLIC_PULSE_URL;
const PULSE_SECRET = process.env.PULSE_SECRET;

export async function broadcastPulseEvent(event: PulseEvent) {
  if (process.env.E2E_TEST_MODE === "true") {
    return;
  }

  if (!PULSE_URL) {
    logger.warn("PULSE_URL not set, skipping pulse event broadcast");
    return;
  }

  if (!PULSE_SECRET) {
    logger.warn("PULSE_SECRET not set, skipping pulse event broadcast");
    return;
  }

  const url = `${PULSE_URL}/publish`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PULSE_SECRET}`,
      },
      body: JSON.stringify(event),
    });

    if (!response.ok) {
      logger.error(`Failed to broadcast pulse event: ${response.statusText}`);
    }

    return response;
  } catch (err) {
    logger.error(`Failed to broadcast pulse event: ${err}`);
  }
}
